import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { loginSuccess } from '../../../redux/reducers/auth';
import { postLogin } from '../../../services/Api';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [payload, setPayload] = useState({ username: '', password: '', remember: 'N' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogin = () => {
        if (!payload.username || !payload.password) {
            window.alert('로그인 아이디, 비밀번호 모두 입력해 주세요.');
            return;
        }

        postLogin(payload)
            .then(({ data }) => {
                dispatch(loginSuccess({ token: data }));
                navigate('/mabaa010');
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    window.alert('로그인 정보는 올바르지 않습니다.');
                }
            });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };
    return (
        <div id="form-login">
            <div className="form-login-content">
                <div className="form-login-logo">
                    <img src="./images/logo.png" alt="logo" style={{ maxWidth: 170 }} />
                </div>
                <form action="#">
                    <label htmlFor="username">
                        <i className="icon icon-nav-user" />
                        <input
                            type="text"
                            placeholder="아이디"
                            id="username"
                            name="username"
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                    </label>
                    <label htmlFor="password">
                        <i className="icon icon-lock" />
                        <input
                            type="password"
                            placeholder="비밀번호"
                            id="password"
                            name="password"
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                    </label>
                    <div className="item-checkBox">
                        <input
                            type="checkbox"
                            className="checkbox"
                            id="rememberPw"
                            onChange={() =>
                                setPayload((prevPayload) => ({
                                    ...prevPayload,
                                    remember: prevPayload.remember === 'Y' ? 'N' : 'Y',
                                }))
                            }
                            checked={payload.remember === 'Y'}
                        />
                        <span />
                        <label htmlFor="rememberPw">로그인 상태 유지</label>
                    </div>
                    <button type="button" onClick={handleLogin}>
                        관리자 로그인
                    </button>
                </form>
            </div>
        </div>
    );
};
export default Login;
